export var formAddAppoInmentAction = {
    actionId: "",
    action: "",
    statusId: "",
    status: "",
    comment: "",
    newAppointmentDate: "",
    approvedPremium: "",
};
export var FormAppointmentActionDTO = {
    section2Title: "Agregar nueva Gestión",
    actionTypeList: [],
    statusListFollowUp: [],
    statusListDecline: [],
    dataForm: {},
    appointmentDateProps: {
        minTime: 8,
        maxTime: 17,
        closeOnSelect: false,
        disableWeekends: true,
        holidays: [],
        disablePast: true,
        disableToday: false,
        readOnly: true,
        ampm: true,
        viewTypes: ["year", "month", "day", "hours", "minutes"],
        formatDate: "DD-MM-YYYY hh:mm a",
        minYears: 1,
        maxYears: 3
    },
    onNext: function () {
    },
    onBlur: function () {
    },
    fields: []
};
